/**
 * Script Name: Submenu Toggle Script
 * Version: 1.0.0
 * Description: Handles submenu toggling functionality in the header.
 * Author: Wubbe
 * Date: December 14, 2023
 */

import './header-1-0';

// Create a MediaQueryList object
var matchDesktop = window.matchMedia("(min-width: 992px)");
// select submenus
const submenu = document.querySelectorAll(".header .menu-item-has-children");
const submenusub = document.querySelectorAll(".header .menu-item-has-children .sub-menu");

// handle the toggle of submenu
function handleToggle(e) {
    console.log('active test!');
    const clickedSubmenu = e.currentTarget;
    if (!clickedSubmenu.classList.contains("is-active")) {
        submenu.forEach(sub => sub.classList.remove("is-active"));
        clickedSubmenu.classList.add("is-active");
        // Toggle overlay or any related actions if needed
    } else {
        clickedSubmenu.classList.remove("is-active");
        // Toggle overlay or any related actions if needed
    }
}

//show or hidden block submenu

submenu.forEach((menuItem) => {
    menuItem.addEventListener("click",(e)=>{
        // if(! matchDesktop.matches) { // mobile 
            console.log('mobile toggle');
            handleToggle(e);
        // }
    });

    menuItem.addEventListener("mouseover",(e)=>{
        if(matchDesktop.matches) { // desktop
            console.log('desktop toggle');
            // handleToggle(e);
            const clickedSubmenu = e.currentTarget;
            submenu.forEach(sub => sub.classList.remove("is-active"));
            clickedSubmenu.classList.add("is-active");
        }
    });

});
submenusub.forEach((menuItem) => { 
    menuItem.addEventListener("mouseleave",(e)=>{ // if you leave the active submenu hide it
        if(matchDesktop.matches) { // desktop
            console.log('desktop toggle');
            // handleToggle(e);
            submenu.forEach(sub => sub.classList.remove("is-active"));
        }
    });

});

document.addEventListener('click', function(e) { // click outside of menu closes it
    const clickedMenuItem = e.target.closest(".menu-item-has-children");
    if (!clickedMenuItem) {
        submenu.forEach(sub => sub.classList.remove("is-active"));
        console.log('close');
    }
});

// scroll check

var isScrolled = false;

// Function to check scroll position and add/remove class
function onScroll() {
    if (window.scrollY > 100) {
        if (!isScrolled) {
            header.classList.add("header-scrolled");
            isScrolled = true; // Update the state to indicate that the class is added
        }
    } else {
        if (isScrolled) {
            header.classList.remove("header-scrolled");
            isScrolled = false; // Update the state to indicate that the class is removed
        }
    }
}

// Add scroll event listener
window.addEventListener("scroll", onScroll);